// BusinessCalendar.tsx
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { it } from "date-fns/locale";
import React from "react";

import { useBusinessCalendarLogic } from "../Logic/FullCalendarLogic";
import { BusinessCalendarUI } from "../UI/FullCalendar";

const BusinessCalendar: React.FC = () => {
  const calendarLogic = useBusinessCalendarLogic();

  if (!calendarLogic) {
    return <p>Loading...</p>;
  }

  const {
    session,
    events,
    selectedEvent,
    isModalOpen,
    isFormOpen,
    isEditMode,
    handleSelectEvent,
    handleSelectSlot,
    handleCloseModal,
    handleCloseForm,
    handleEditEvent,
    handleDeleteEvent,
    handleSaveEvent,
  } = calendarLogic;

  if (!session || !session.selectedBusiness || !session.selectedBusiness.id) {
    return <p>Please select a business to continue</p>;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
      <BusinessCalendarUI
        events={events}
        selectedEvent={selectedEvent}
        isModalOpen={isModalOpen}
        isFormOpen={isFormOpen}
        isEditMode={isEditMode}
        onSelectEvent={handleSelectEvent}
        onSelectSlot={handleSelectSlot}
        onCloseModal={handleCloseModal}
        onCloseForm={handleCloseForm}
        onEditEvent={handleEditEvent}
        onDeleteEvent={handleDeleteEvent}
        onSaveEvent={handleSaveEvent}
      />
    </LocalizationProvider>
  );
};

export default BusinessCalendar;
